// src/components/DeepCreatures.jsx
import React from 'react';
import SwimmingDuckBillCatfish from './DuckBillCatfish.jsx';
import SwimmingFirewoodCatfish from './FirewoodCatfish.jsx';
import SwimmingLongTailedRiverStingray from './LongTailedRiverStingray.jsx';
import SwimmingMarbledLongWhiskeredCatfish from './MarbledLongWhiskeredCatfish.jsx';
import SwimmingMarbledPimelodidCatfish from './MarbledPimelodidCatfish.jsx';
import SwimmingSurubimCatfish from './SurubimCatfish.jsx';

const boolEnv = (key, defaultVal = true) => {
    const raw = process.env[key];
    if (raw == null) return defaultVal;
    const v = String(raw).trim().toLowerCase();
    if (v === '1' || v === 'true' || v === 'yes' || v === 'on') return true;
    if (v === '0' || v === 'false' || v === 'no' || v === 'off' || v === '') return false;
    return defaultVal;
};

export default function DeepCreatures({
    zone,
    onCreatureClick,
    highlightVersion,
}) {
    const isHighlighted = (versionNumber) =>
        highlightVersion != null && String(versionNumber) === String(highlightVersion);

    // Flags (default ON)
    const showMarbledLongWhiskered = boolEnv('REACT_APP_SHOW_MARBLED_LONG_WHISKERED_CATFISH', true);
    const showMarbledPimelodid = boolEnv('REACT_APP_SHOW_MARBLED_PIMELODID_CATFISH', true);
    const showStingray = boolEnv('REACT_APP_SHOW_LONG_TAILED_RIVER_STINGRAY', true);
    const showDuckBill = boolEnv('REACT_APP_SHOW_DUCK_BILL_CATFISH', true);
    const showFirewood = boolEnv('REACT_APP_SHOW_FIREWOOD_CATFISH', true);
    const showSurubim = boolEnv('REACT_APP_SHOW_SURUBIM_CATFISH', true);

    const v0 = zone?.versions?.[0];
    const v1 = zone?.versions?.[1];
    const v2 = zone?.versions?.[2];
    const v3 = zone?.versions?.[3];
    const v4 = zone?.versions?.[4];
    const v5 = zone?.versions?.[5];

    const handleClick = (v, name) => {
        if (onCreatureClick) onCreatureClick(v);
        else console.warn(`[DeepCreatures] onCreatureClick not provided; clicked ${name}`, v);
    };

    const fishWidth = 100;

    return (
        <section className="relative w-full h-64 overflow-visible">
            {/* Long-Tailed River Stingray (bobbing, sits low) */}
            {showStingray && v0 && (
                <SwimmingLongTailedRiverStingray
                    width={90}
                    top="92%"
                    left="50%"
                    zIndex={10}
                    highlight={isHighlighted(v0.versionNumber)}
                    onClick={() => handleClick(v0, 'LongTailedRiverStingray')}
                />
            )}

            {/* Duck-Bill Catfish */}
            {showDuckBill && v1 && (
                <SwimmingDuckBillCatfish
                    width={fishWidth}
                    swimDuration="50s"
                    minTop={80}
                    maxTop={100}
                    zIndex={30}
                    highlight={isHighlighted(v1.versionNumber)}
                    onClick={() => handleClick(v1, 'DuckBillCatfish')}
                />
            )}

            {/* Firewood Catfish */}
            {showFirewood && v2 && (
                <SwimmingFirewoodCatfish
                    width={fishWidth}
                    swimDuration="60s"
                    minTop={40}
                    maxTop={70}
                    zIndex={15}
                    highlight={isHighlighted(v2.versionNumber)}
                    onClick={() => handleClick(v2, 'FirewoodCatfish')}
                />
            )}

            {/* Surubim Catfish (ensure lane is 20–30%) */}
            {showSurubim && v3 && (
                <SwimmingSurubimCatfish
                    width={150}
                    swimDuration="70s"
                    minTop={20}
                    maxTop={30}
                    zIndex={20}
                    highlight={isHighlighted(v3.versionNumber)}
                    onClick={() => handleClick(v3, 'SurubimCatfish')}
                />
            )}

            {/* Marbled Long-Whiskered Catfish */}
            {showMarbledLongWhiskered && v4 && (
                <SwimmingMarbledLongWhiskeredCatfish
                    width={fishWidth}
                    swimDuration="90s"
                    minTop={90}
                    maxTop={110}
                    zIndex={25}
                    highlight={isHighlighted(v4.versionNumber)}
                    onClick={() => handleClick(v4, 'MarbledLongWhiskeredCatfish')}
                />
            )}

            {/* Marbled Pimelodid Catfish */}
            {showMarbledPimelodid && v5 && (
                <SwimmingMarbledPimelodidCatfish
                    width={fishWidth}
                    swimDuration="30s"
                    zIndex={35}
                    highlight={isHighlighted(v5.versionNumber)}
                    onClick={() => handleClick(v5, 'MarbledPimelodidCatfish')}
                />
            )}
        </section>
    );
}
